import i18n from '@/locales'
import axios from "axios";

export default {
  namespaced: true,
  // Estado, las variables que se guardan
  state: {
    token: "",
    admin: false,
    nombreEstudiante: "",
    emailEstudiante: "",
    emailSuplanta: "",
    uniCodigo: "",
  },
  // Mutaciones, las únicas que pueden modificar el estado, accesibles solo desde las acciones
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    REVOKE_TOKEN(state) {
      state.token = "";
    },
    SET_ADMIN(state, admin) {
      state.admin = admin;
    },
    REVOKE_ADMIN(state) {
      state.admin = false;
    },
    SET_NOMBRE_ESTUDIANTE(state, nombreEstudiante) {
      state.nombreEstudiante = nombreEstudiante;
    },
    REVOKE_NOMBRE_ESTUDIANTE(state) {
      state.nombreEstudiante = "";
    },
    SET_EMAIL_ESTUDIANTE(state, emailEstudiante) {
      state.emailEstudiante = emailEstudiante;
    },
    REVOKE_EMAIL_ESTUDIANTE(state) {
      state.emailEstudiante = "";
    },
    SET_EMAIL_SUPLANTA(state, emailSuplanta) {
      state.emailSuplanta = emailSuplanta;
    },
    REVOKE_EMAIL_SUPLANTA(state) {
      state.emailSuplanta = "";
    },
    SET_UNI_CODIGO(state, uniCodigo) {
      state.uniCodigo = uniCodigo;
    },
    REVOKE_UNI_CODIGO(state) {
      state.uniCodigo = "";
    },
  },
  // Acciones, funciones normales que ademés pueden llamar a las mutaciones
  actions: {
    setToken({ commit }, datos) {
      commit("SET_TOKEN", datos.token);
      commit("SET_ADMIN", datos.admin);
      commit("SET_NOMBRE_ESTUDIANTE", datos.nombreEstudiante);
      commit("SET_EMAIL_ESTUDIANTE", datos.emailEstudiante);
      commit("SET_EMAIL_SUPLANTA", datos.emailSuplanta);
      commit("SET_UNI_CODIGO", datos.uniCodigo);
    },
    revokeDatos({ commit }, datos) {
      commit("REVOKE_TOKEN");
      commit("REVOKE_ADMIN");
      commit("REVOKE_NOMBRE_ESTUDIANTE");
      commit("REVOKE_EMAIL_ESTUDIANTE");
      commit("REVOKE_EMAIL_SUPLANTA");
      commit("REVOKE_UNI_CODIGO");
    },
    revokeToken({ commit }) {
      commit("REVOKE_TOKEN");
    },
    revokeAdmin({ commit }) {
      commit("REVOKE_ADMIN");
    },
    revokeNombreEstudiante({ commit }) {
      commit("REVOKE_NOMBRE_ESTUDIANTE");
    },
    revokeEmailEstudiante({ commit }) {
      commit("REVOKE_EMAIL_ESTUDIANTE");
    },
    revokeEmailSuplanta({ commit }) {
      commit("REVOKE_EMAIL_SUPLANTA");
    },
    revokeUniCodigo({ commit }) {
      commit("REVOKE_UNI_CODIGO");
    },
    refreshToken({ commit, state }) {
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
      axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
      return axios
        .post("/cursos/secretaria.publico.refreshToken.do", { mode : 'no-cors', }, { "headers": { "auth-token": state.token } } )
        .then((response) => response.data)
        .then((token) => {
          commit("SET_TOKEN", token.token);
        })
        .catch(() => {
          //commit("REVOKE_TOKEN");
          console.log('No se puede renovar el token, no cogió proxy');
        });
    },    

  },
  // Getters
  getters: {
    isLogged: (state) => state.token !== null && state.token !== "",
    getToken: (state) => state.token,
    isAdmin: (state) => state.admin,
    getNombreEstudiante: (state) => state.nombreEstudiante,
    getEmailEstudiante: (state) => state.emailEstudiante,
    getEmailSuplanta: (state) => state.emailSuplanta,
    getUniCodigo: (state) => state.uniCodigo,

    // CURSOS-1135
    /*
    urlLoginServicios: () => `https://cursostest.um.es/cursos/secretaria.servicios.listado.do`,
    urlLoginCertic: () => `https://cursostest.um.es/cursos/secretariaCERTIC`,
    urlLoginEEPP: () => `https://cursostest.um.es/cursos/secretariaEEPP`,
    urlLoginUnimar: () => `https://cursostest.um.es/cursos/secretariaUNIMAR`,
    UrlLoginGenerica: () => `https://cursostest.um.es/cursos/alumnos.secretariavirtual.login.do`,
    */
    urlLoginServicios: () => `https://cursos.um.es/cursos/secretaria.servicios.listado.do`,
    urlLoginCertic: () => `https://cursos.um.es/cursos/secretariaCERTIC`,
    urlLoginEEPP: () => `https://cursos.um.es/cursos/secretariaEEPP`,
    urlLoginUnimar: () => `https://cursos.um.es/cursos/secretariaUNIMAR`,
    UrlLoginGenerica: () => `https://cursos.um.es/cursos/alumnos.secretariavirtual.login.do`,
    urlLogin: (state, getters) => {
      var url;
      switch (state.uniCodigo) {
        case 'CERTI': url = getters.urlLoginCertic; break;
        case 'CA': url = getters.urlLoginEEPP; break;
        case 'CU': url = getters.urlLoginUnimar; break;
        default: url = getters.UrlLoginGenerica;
      }
    return url;
    },
    nombreApp: function (state) {
      var nombre;
      switch (state.uniCodigo) {
        case 'CA': nombre = i18n.t("nombre_EEPP"); break;
        case 'CERTI': nombre = i18n.t("nombre_certic"); break;
        case 'CU': nombre = i18n.t("nombre_unimar"); break;
        default: nombre = i18n.t("nombre_default");
      }
      return nombre
    },
    emailApp: function (state) {
      var email;
      switch (state.uniCodigo) {
        case 'CA': email = 'estudiospropios@um.es'; break;
        case 'CERTI': email = 'certic@um.es'; break;
        case 'CU': email = 'unimar@um.es'; break;
        default: email = 'estudiantes@um.es';
      }
      return email
    },
    telefonoApp: function (state) {
      var telefono;
      switch (state.uniCodigo) {
        case 'CA': telefono = '868 88 3321'; break;
        case 'CERTI': telefono = '868 88 4311'; break;
        case 'CU': telefono = '868 88 3000'; break;
        default: telefono = '868 88 8888';
      }
      return telefono
    },
    textoDiploma: function (state) {
      var textoDiploma;
      switch (state.uniCodigo) {
        case 'CERTI': textoDiploma = i18n.t("diploma_certic"); break;
        default: textoDiploma = i18n.t("diploma_default");
      }
      return textoDiploma
    },
    textoDiplomas: function (state) {
      var textoDiplomas;
      switch (state.uniCodigo) {
        case 'CERTI': textoDiplomas = i18n.t("diplomas_certic"); break;
        default: textoDiplomas = i18n.t("diplomas_default");
      }
      return textoDiplomas
    },

    textoDiplomasCap: function (state) {
      var textoDiplomasCap;
      switch (state.uniCodigo) {
        case 'CERTI': textoDiplomasCap = i18n.t("diplomas_certic_cap"); break;
        default: textoDiplomasCap = i18n.t("diplomas_default_cap");
      }
      return textoDiplomasCap
    },
  },

  
};